import api from 'Api';
import { UserRoles } from '../constants/userRoles';

export class AppService {
  // This contains methods that handle app level requests
  async getUserData(emailAddress) {
    var response = await api.get('/users', {
      params: {
        email: emailAddress
      }
    });
    return response.data.data;
  }

  async getUserById(userId) {
    var response = await api.get('/users', {
      params: {
        ids: userId
      }
    });
    // this return list of user that is why index 0
    return response.data.data[0];
  }

  async getBusinessProfile(name, referralCode, storeDomain, currencyId = 17, timeZoneId = 142) {
    var response = await api.post('/businessProfiles', {
      name,
      currencyId,
      timeZoneId,
      IsRoimatic: true,
      referralCode,
      storeDomain
    });
    return response.data;
  }

  async assignUserAccess(userId, businessProfileId) {
    await api.post(`/users/${userId}/businessProfiles/${businessProfileId}`, {
      role: UserRoles.BizgainAdmin
    })
    return;
  }

  async assignBusinessProfilePortalAccess(businessProfileId, portalId) {
    await api.post(`/businessProfiles/${businessProfileId}/portals/${portalId}`)
    return;
  }

  async createProductCatalog(businessProfileId, name) {
    let response = await api.post(`/businessProfiles/${businessProfileId}/ProductCatalogs`, { name });
    return response.data;
  }

  async getProductCatalog(businessProfileId, productCatalogId) {
    let response = await api.get(`/businessProfiles/${businessProfileId}/ProductCatalogs/${productCatalogId}`);
    return response.data.data;
  }

  async createProductFeed(businessProfileId, name, productCatalogId, url) {
    let params = {
      name,
      productCatalogId,
      url
    };
    let response = await api.post(`/businessProfiles/${businessProfileId}/ProductFeeds`, params);
    return response.data.data;
  }

  async createTask(businessProfileId, id, productCatalogId, engine, isDirectTask, isApiUploadRequired, productMappings) {
    let productMaps = productMappings === undefined || productMappings === null ? [] : productMappings;

    let params = {
      productCatalogId,
      engine,
      isDirectTask,
      isApiUploadRequired,
      productMaps
    };
    await api.post(`/businessProfiles/${businessProfileId}/productFeeds/${id}/process`, params);
  }
  async getBusinessProfileById(id)
  {
    var response = await api.get(`/businessProfiles/${id}`);
    return response.data.data;
  }

  async getPortalBusinessProfiles(userId, portalId, isRoimatic = null, roleId = 0) {
    let params = {
      roleId: roleId
    }
    if(isRoimatic){
      params.isRoimatic = isRoimatic
    }
    var response = await api.get(`/portals/${portalId}/users/${userId}/businessProfiles`, {
      params
    })
    return response.data.data;
  }

  async getUserBusinessProfiles(userId, isRoimatic = null) {
    let params = {
      isRoimatic: isRoimatic
    }
    var response = await api.get(`/users/${userId}/businessProfiles`, {
      params
    });
    return response.data.data;
  }

  async getCurrencies() {
    var response = await api.get('/currencies');
    let currencies = response.data.data;
    let currencyinfos = [];
    currencies.forEach((currency) => {
      let currencyinfo = {};
      currencyinfo.id = currency.id;
      currencyinfo.code = currency.code;
      currencyinfo.displayName = currency.displayName;
      currencyinfo.currencyOffset = currency.currencyOffset;
      currencyinfos.push(currencyinfo);
    });
    return currencyinfos;
  }
  async getTimeZones() {
    var response = await api.get('/timezones');
    return response.data.data;
  }

  async updateBusinessProfile(businessProfileId, businessProfile) {
    var payload = JSON.stringify(JSON.stringify({ 'data': businessProfile }));
    await api.patch(`/businessProfiles/${businessProfileId}`, payload, {
      headers: {
        'Content-type': 'application/json'
      }
    });
  };

  async uploadBusinessProfileLogo(bpId, file) {
    var formData = new FormData();
    formData.append('logoFile', file);
    var response = await api.post(`/businessProfiles/${bpId}/logo`, formData, {
      headers: {
        'Content-type': 'multipart/form-data'
      }
    });
    return response.data.data;
  }

  async getCurrencyInfo(currencyId, businessProfileId) {
    var response = await api.get(
      `/businessProfiles/${businessProfileId}/currencies/${currencyId}`
    );
    return response.data.data;
  }

  async getSearchCreatives(businessProfileId, theme) {
    let response = await api.get(
      `/businessProfiles/${businessProfileId}/roimatic/getSearchCreatives`, {
        params: {
          theme: theme
        } }
    );
    return response.data.data;
  }

  async getCountries() {
    var response = await api.get('/ip2locations/countries');
    return response.data.data;
  }

  async resetPassword(userId, currentPassword, newPassword) {
    await api.post(`/users/${userId}/resetPassword`, {
      currentPassword,
      newPassword
    });
  }

  async placeCallbackRequest(userId, number, businessProfileId) {
    await api.post('/users/callback', {
      businessProfileId: businessProfileId ? businessProfileId : null,
      phone: number,
      id: userId ? userId : null,
      portal: window.location.host
    });
  }

  async getUserInformation(userId) {
    return await api.get(`/users/${userId}`);
  }
  async updateUserInformation(userId, data) {
    await api.put(`/users/${userId}`, data);
  }

  async subscribeUserPushNotification(userId, payload){
    await api.post(`/users/${userId}/subscribe`, payload);
  }

  async unsubscribeUserPushNotification(userId, payload){
    await api.post(`users/${userId}/unsubscribe`, payload);
  }

  async setupLocalBusiness(businessProfileId, businessName) {
    let postData = {
      businessName,
      outlet: 'roimatic.adbox.pro',
      category: 'local-business',
      flavour: 'local-business'
    };
    await api.post(`/businessProfiles/${businessProfileId}/roimatic/localBusiness`, postData)
  }

  async getAllLanguages() {
    let response = await api.get('dxlanguages');
    return response.data.data;
  }

  async getUserDivisions(userId, portalId) {
    let response = await api.get(`/users/${userId}/portals/${portalId}/divisions`);
    return response.data.data;
  }

  async editUserInformation(userId, data) {
    var payload = JSON.stringify(JSON.stringify(data));
    await api.patch(`/users/${userId}`, payload, {
      headers: {
        'Content-type': 'application/json'
      }
    });
  }

  async sendOtpToUpdateUser(userId, data){
    let response = await api.post(`/users/${userId}/sendotp`, data)
    return response.data;
  }

  async getDefaultPortalByBusinessProfile(businessProfileId){
    let response = await api.get(`businessProfile/${businessProfileId}/portals`, {
      params: {
        type: 'default'
      }
    });
    return response.data.data;
  }

  async validateOtpToUpdateUser(userId, data){
    let response = await api.post(`/users/${userId}/validateOtp`, data)
    return response.data;
  }

  async getCurrencyInfoByRegion(region) {
    var response = await api.get('/localbusiness/currencies', {
      params: {
        region
      }
    }
    );
    return response.data.data;
  }

  async validateGST(payload){
    var response = await api.post('/localBusiness/verifyGST', payload);
    return response.data.data;
  }
}